<template>
  <template v-if="stock">
    <StockImageTag
      :isPostTicker="true"
      :disableRouting="false"
      :stockId="stock._id"
      :imgUrl="stock.logoUrl"
      :symbol="stock.symbol"
      :market="stock.type"
    />
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, nextTick } from "vue";
import { useSocketStockData } from "@/composables/stock_data.composable";
import { useStockSocket } from "@/composables/stock_socket.composable";

export default defineComponent({
  props: ["stockTag"],
  setup(props, context) {
    const { addStockId, checkStockExistence } = useStockSocket();

    const initialObject = () => {
      let obj = {
        _id: props.stockTag.stockId,
        symbol: props.stockTag.symbol,
        market: props.stockTag.market,
        type: props.stockTag.market,
      };
      if (!checkStockExistence(props.stockTag?.stockId)) {
        addStockId({ showTrendChart: true, stockId: props.stockTag?.stockId });
      }
      return obj;
    };

    const { stockData: stock, updateStockInfoObject } = useSocketStockData(
      initialObject()
    );

    watch(
      () => props.stockTag,
      async (newStockData) => {
        updateStockInfoObject(initialObject());
        await nextTick(); // Ensure DOM updates immediately
      },
      { deep: true } // Ensure deep watching
    );

    onMounted(() => {
      updateStockInfoObject(initialObject());
    });

    return {
      stock,
    };
  },
});
</script>
